import Cargos from '@/models/Cargos'

export default [
  {
    path: '/atendimento/fechamentos',
    name: 'rota-fechamentos',
    autenticado: true,
    cargo: [Cargos.LIDER, Cargos.ATENDENTE],
    titulo: 'Fechamento do dia',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Fechamento do dia',
      icon: 'cash-register',
    },
    component: () => import(/* webpackChunkName: "fechamento" */ '../views/fechamento/Fechamento.vue'),
  },
]
